import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';

import { ContextService } from '../core/context.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private contextService: ContextService) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url: string = state.url;
    const screens = route.data['screens'] as Array<string>;

    return this.checkAccess(url, screens);
  }

  checkAccess(url: string, screens: Array<string>): boolean {
    if (this.contextService.isLoggedIn === false) {
      this.contextService.redirectUrl = url;
      this.router.navigate(['/login']);
      return false;
    }

    return this.contextService.hasAnyScreenPermission(screens);
  }

  checkScreen(screenCode: string, screens: Array<string>): boolean {
    let found = false;
    for (let index = 0; index < screens.length; index++) {
        const code: string = screens[index];
        if (code.localeCompare(screenCode) === 0) {
          found = true;
          break;
        }
    }

    return found;
  }

}
